(() => {
  if (window.cvVariantColorInit) return;
  window.cvVariantColorInit = true;

  const RACINE = '[data-cv-variant-colors]';
  const TUILE = '[data-cv-color-tile]';

    const grouperMedias = () => {
    const groupes = new Map();

    for (const media of document.querySelectorAll('[data-media-id]')) {
      const conteneur = media.closest('.product-media-container') || media;
      const cle = conteneur.parentElement;
      if (!cle) continue;
      if (!groupes.has(cle)) groupes.set(cle, []);
      groupes.get(cle).push(media);
    }

    return groupes;
  };

    const permuterVersMedia = (idMedia) => {
    if (!idMedia) return false;
    let permute = false;

    for (const medias of grouperMedias().values()) {
      const principal = medias[0];
      const cible = medias.find((m) => m.dataset.mediaId === idMedia);
      if (!principal || !cible || principal === cible) continue;

      const contenu = principal.innerHTML;
      const style = principal.getAttribute('style');
      const id = principal.dataset.mediaId;

      principal.innerHTML = cible.innerHTML;
      principal.dataset.mediaId = cible.dataset.mediaId;
      if (cible.getAttribute('style')) {
        principal.setAttribute('style', cible.getAttribute('style'));
      } else {
        principal.removeAttribute('style');
      }

      cible.innerHTML = contenu;
      cible.dataset.mediaId = id;
      if (style) cible.setAttribute('style', style);
      else cible.removeAttribute('style');

      permute = true;
    }

    return permute;
  };

    const majFormulaire = (racine, idVariante) => {
    const connus = new Set(
      [...racine.querySelectorAll(TUILE)].map((t) => t.dataset.variantId)
    );

    for (const champ of document.querySelectorAll('input[name="id"]')) {
      if (connus.has(champ.value)) champ.value = idVariante;
    }
  };

  document.addEventListener('click', (event) => {
    const tuile = event.target.closest(TUILE);
    if (!tuile) return;

    const racine = tuile.closest(RACINE);
    if (!racine) return;

    // Clic milieu ou avec modificateur : on laisse le navigateur ouvrir le lien
    // dans un nouvel onglet, comportement attendu d'un `<a>`.
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      return;
    }

    if (tuile.dataset.unavailable === 'true') return;

    const idVariante = tuile.dataset.variantId;
    if (!idVariante) return;

    event.preventDefault();

    permuterVersMedia(tuile.dataset.mediaId);
    majFormulaire(racine, idVariante);

    for (const autre of racine.querySelectorAll(TUILE)) {
      autre.setAttribute('aria-current', autre === tuile ? 'true' : 'false');
    }

    // URL alignée sur la sélection, sans rechargement : le lien reste
    // partageable et un rafraîchissement garde la couleur.
    const url = new URL(window.location.href);
    url.searchParams.set('variant', idVariante);
    window.history.replaceState({}, '', url);
  });
})();
